import React, { useRef, useState } from 'react';
import Sound from './game_audio.m4a'
import './Spin.scss';

const Spin = ({ onSpin, onStop, isSpinning, stop }) => {

  const audioRef = useRef(null);
  const handleSpin = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
    onSpin();
  };

  const handleStop = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    onStop();
  };

  return (
    <div className="SpinStop">
      <audio ref={audioRef} src={Sound} loop />
      {!stop && !isSpinning && <button onClick={handleSpin} className="SpinButton">Spin</button>}
      {isSpinning && <button onClick={handleStop} className="StopButton">Stop</button>}
    </div>
  );
};

export default Spin;